<template>
  <div>
    <div class="logo-div">
      <div class="logo">
        <img :src="appLogo" />
      </div>
      <div class="title theme_font_color">我的物品</div>
    </div>
    <div class="title-div theme_font_color">
      <span @click="hanldClick('https://www.pgyer.com/ozeY')">下载APP</span>
      <span @click="hanldClick('http://moshouapphelp.zendesk.com')">FAQ</span>
      <span @click="hanldClick('login')">登录</span>
    </div>
  </div>
</template>

<script>
import appLogo from '../assets/images/lightImgs/logo_header.png'

export default {
  name: 'headeritem',
  data() {
    return {
      appLogo,
    }
  },
  methods: {
    hanldClick(url) {
      if (url !== 'login') {
        window.open(url, '_blank')
      } else {
        this.$router.push('/login')
      }
    },
  },
}
</script>
<style  lang="less" scoped>
.logo-div {
  line-height: 60px;
  display: flex;
  float: left;
  .logo {
    img {
      vertical-align: middle;
      height: 50px;
    }
  }
  .title {
    font-size: 18px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #3c3c3c;
  }
}
.title-div {
  float: right;
  line-height: 60px;
  display: flex;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3c3c3c;
  letter-spacing: 2px;
  span {
    margin: 0 15px;
    cursor: pointer;
  }
  span:hover {
    color: rgba(255, 204, 0, 1);
  }
}
</style>